import { 
  Box, 
  Dialog, 
  DialogTitle, 
  Typography, 
  DialogContent,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Chip,
  Button,
  Alert
} from "@mui/material";
import React, { useState, useEffect } from "react";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';

function CambiarPago(props) {
  const [cambiarPago, setCambiarPago] = useState(props.cambiarPago);
  const [pedidosFacturados, setPedidosFacturados] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [cargando, setCargando] = useState(false);

  // console.log(props.pedido);

  const handleClose = () => {
    setCambiarPago(!cambiarPago);
    if (props.onClose) {
      props.onClose();
    }
  };

  // Función para cargar pedidos facturados de la misma dirección y mismo día
  const cargarPedidosFacturados = async () => {
    if (!props.pedido) return;
    
    setCargando(true);
    try {
      // Obtener la fecha del pedido original (sin hora)
      const fechaPedidoOriginal = props.pedido.fecha_format.split(' ')[0]; // "30-04-2026"
      
      // Aquí va tu llamada a la API con los filtros
      // Ejemplo: 
      // const response = await api.obtenerPedidosFacturados({
      //   id_direccion: props.pedido.id_direccion,
      //   fecha: fechaPedidoOriginal,
      //   estado_facturado: true // o estado que indique facturado
      // });
      // setPedidosFacturados(response.data);
      
      // DATOS DE EJEMPLO (reemplazar con tu API)
      const pedidosEjemplo = [
        {
          id: 1933,
          id_direccion: 156106,
          direccion_entrega: "500 VV MZ61-14-1 10",
          fecha_format: "30-04-2026",
          cliente: "DE SEDOYA SILVIA",
          producto: "2 X 10kg",
          valor: 25000,
          estado_facturado: true,
          tipo: 1,
          uuid_pedido: "52b6dd74-8fde-4a0a-86a5-c516e0130303",
          sucursal_cliente: "Pta Corrientes"
        },
        {
          id: 1934,
          id_direccion: 156106,
          direccion_entrega: "500 VV MZ61-14-1 10",
          fecha_format: "30-04-2026",
          cliente: "DE SEDOYA SILVIA",
          producto: "3 X 10kg",
          valor: 37500,
          estado_facturado: true,
          tipo: 2,
          uuid_pedido: "68c7dd85-9aef-5b1b-97b6-d627f0241144",
          sucursal_cliente: "Pta Corrientes"
        },
        {
          id: 1935,
          id_direccion: 156106,
          direccion_entrega: "500 VV MZ61-14-1 10",
          fecha_format: "30-04-2026",
          cliente: "DE SEDOYA SILVIA",
          producto: "1 X 15kg",
          valor: 18750,
          estado_facturado: true,
          tipo: 1,
          uuid_pedido: "79d8ee96-0bfg-6c2c-08c7-e738g1352255",
          sucursal_cliente: "Pta Corrientes"
        }
      ];
      
      setPedidosFacturados(pedidosEjemplo);
      
    } catch (error) {
      console.error("Error cargando pedidos facturados:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (cambiarPago && props.pedido) {
      cargarPedidosFacturados();
    }
  }, [cambiarPago, props.pedido]);

  // Función para asignar el pago al pedido seleccionado
  const asignarPago = () => {
    if (pedidoSeleccionado) {
      // console.log("Asignando pago del pedido", props.pedido.id, "al pedido", pedidoSeleccionado.id);
      // Aquí va tu lógica para transferir el pago
      // Ejemplo: await api.transferirPago(props.pedido.id, pedidoSeleccionado.id);
      handleClose();
    }
  };

  // Formatear moneda
  const formatearMoneda = (valor) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(valor);
  };

  return (
    <Dialog
      fullWidth
      open={cambiarPago}
      onClose={handleClose}
      maxWidth="md"
    >
      <Box backgroundColor="#1F618D">
        <DialogTitle>
          <Typography fontSize={20} align="center" color="#ffffff">
            Cambiar de pedido el pago del pedido N°{props.pedido?.id || ''}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent sx={{ p: 3 }}>
        {/* SECCIÓN SUPERIOR - Datos del pedido original */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#1F618D' }}>
            Datos del pedido original
          </Typography>
          <Paper elevation={2} sx={{ p: 2, bgcolor: '#f5f5f5' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="textSecondary">
                  <strong>N° Pedido:</strong> {props.pedido?.id}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Cliente:</strong> {props.pedido?.cliente}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Dirección:</strong> {props.pedido?.direccion_entrega}
                </Typography>

              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Fecha:</strong> 
                  <CalendarTodayIcon fontSize="small" sx={{ ml: 1, mr: 0.5, verticalAlign: 'middle' }} />
                  {props.pedido?.fecha_format}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Producto:</strong> {props.pedido?.producto}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Estado:</strong> 
                  <Chip 
                    size="small" 
                    label={props.pedido?.valor || "Facturado"} 
                    color="success"
                    sx={{ ml: 1 }}
                  />
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Sucursal:</strong> {props.pedido?.sucursal_cliente}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Box>

        <Divider sx={{ my: 3 }}>
          <Chip label="Transferir pago a otro pedido" size="medium" color="primary" />
        </Divider>

        {/* SECCIÓN INFERIOR - Selector de pedido destino */}
        <Box>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#1F618D', mb: 2 }}>
            Seleccionar pedido destino
          </Typography>

          {/* Información de filtros aplicados */}
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Filtros aplicados:</strong> Misma dirección y misma fecha ({props.pedido?.fecha_format})
            </Typography>
          </Alert>

          {/* Selector de pedidos facturados */}
          {pedidosFacturados.length > 0 ? (
            <>
              <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                <InputLabel>Pedidos facturados disponibles</InputLabel>
                <Select
                  value={pedidoSeleccionado?.id || ''}
                  onChange={(e) => {
                    const pedido = pedidosFacturados.find(p => p.id === e.target.value);
                    setPedidoSeleccionado(pedido);
                  }}
                  label="Pedidos facturados disponibles"
                  disabled={cargando}
                >
                  {pedidosFacturados.map((pedido) => (
                    <MenuItem key={pedido.id} value={pedido.id}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>Pedido N° {pedido.id}</span>
                        <span style={{ marginLeft: '20px' }}>{pedido.producto}</span>
                        <span style={{ marginLeft: '20px', fontWeight: 'bold' }}>
                          {formatearMoneda(pedido.valor)}
                        </span>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Mostrar detalles del pedido seleccionado */}
              {pedidoSeleccionado && (
                <Paper elevation={3} sx={{ p: 2, mt: 2, border: '2px solid #4caf50', bgcolor: '#f1f8e9' }}>
                  <Typography variant="subtitle2" color="success.main" gutterBottom>
                    Pedido seleccionado para recibir el pago:
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2">
                        <strong>N° Pedido:</strong> {pedidoSeleccionado.id}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Producto:</strong> {pedidoSeleccionado.producto}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Cliente:</strong> {pedidoSeleccionado.cliente}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2">
                        <strong>Dirección:</strong> 
                        <LocationOnIcon fontSize="small" sx={{ ml: 1, mr: 0.5, verticalAlign: 'middle' }} />
                        {pedidoSeleccionado.direccion_entrega}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Monto del pedido:</strong> {formatearMoneda(pedidoSeleccionado.valor)}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Estado actual:</strong> Facturado
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              )}
            </>
          ) : (
            <Alert severity="warning" sx={{ mt: 2 }}>
              No se encontraron pedidos facturados para la dirección {props.pedido?.direccion_entrega} en la fecha {props.pedido?.fecha_format}
            </Alert>
          )}

          {/* Botones de acción */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
            <Button variant="outlined" onClick={handleClose}>
              Cancelar
            </Button>
            <Button 
              variant="contained" 
              onClick={asignarPago}
              disabled={!pedidoSeleccionado || pedidosFacturados.length === 0}
              sx={{ bgcolor: '#1F618D', '&:hover': { bgcolor: '#145A82' } }}
            >
              Transferir pago a este pedido
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CambiarPago;